import { render } from "./authSystem.vue?vue&type=template&id=274e2926&scoped=true"
import script from "./authSystem.vue?vue&type=script&lang=js"
export * from "./authSystem.vue?vue&type=script&lang=js"

import "./authSystem.vue?vue&type=style&index=0&id=274e2926&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_Ejzw/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274e2926"]])

export default __exports__